import { ClassCodeFlightEnum, OriginTypeFlightEnum } from '@msc-b2c/interfaces/enums';
import { AirfareRequest } from '../../../../../../interfaces/src/lib/types/index';

export const airfairsRequestMock: AirfareRequest[] = [
  {
    origin: 'LHR',
    destination: 'BCN',
    departureDate: '2024-09-20',
    returnDate: '2024-09-27',
    originType: OriginTypeFlightEnum.AIRPORT,
    priceCode: 'EUF01299GB4010SM',
    passengerInformation: {
      adults: { total: 2 },
      children: { total: 0, details: [] },
    },
    classCode: ClassCodeFlightEnum.ECONOMY,
    airlineCode: '*',
  },
];
